"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../helpers/index.js");
var stringField = _index.formatters.stringField,
  numberField = _index.formatters.numberField;
var getProductCartViewsTemplate = function getProductCartViewsTemplate(_ref) {
  var cartID = _ref.cartID,
    cartSource = _ref.cartSource,
    numberOfAccessories = _ref.numberOfAccessories,
    numberOfPhones = _ref.numberOfPhones,
    numberOfTablets = _ref.numberOfTablets,
    numberOfWatches = _ref.numberOfWatches;
  return {
    productListViews: {
      value: 1
    },
    cart: {
      cartID: cartID,
      cartSource: stringField(cartSource)
    },
    _telus: {
      numberOfAccessories: numberField(numberOfAccessories),
      numberOfPhones: numberField(numberOfPhones),
      numberOfTablets: numberField(numberOfTablets),
      numberOfWatches: numberField(numberOfWatches)
    }
  };
};
var _default = exports["default"] = getProductCartViewsTemplate;